import { ApolloQueryResult } from '@apollo/client'
import { useCidadaosCadastroImovelQuery } from 'graphql/hooks.generated'
import { CidadaosCadastroImovelQuery, CidadaoTerritorio } from 'graphql/types.generated'
import { useMemo } from 'react'
import { isUndefinedOrNull } from 'util/checks'

interface UseCidadaosImovelResult {
  cidadaos: ReadonlyArray<CidadaoTerritorio>
  loading: boolean
  refetch: () => Promise<ApolloQueryResult<CidadaosCadastroImovelQuery>>
}

export function useCidadaosImovel(cidadaosIds?: ReadonlyArray<ID | null | undefined>): UseCidadaosImovelResult {
  const validCidadaosIds = useMemo(
    () => cidadaosIds?.filter((cidadaoId): cidadaoId is ID => !isUndefinedOrNull(cidadaoId)) ?? [],
    [cidadaosIds]
  )

  const {
    data: { cidadaosTerritorio },
    previousData,
    loading,
    refetch,
  } = useCidadaosCadastroImovelQuery({
    variables: {
      input: validCidadaosIds,
    },
    fetchPolicy: 'cache-and-network',
    skip: validCidadaosIds.isEmpty(),
  })

  const cidadaos = cidadaosTerritorio ?? previousData?.cidadaosTerritorio

  return { cidadaos, loading: loading && !cidadaos, refetch }
}
